import { IconProps } from "../../types/utils";

const ProfileIcon2 = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 26}
    height={dimension || 28}
    viewBox="0 0 26 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.3149 21.3762L16.5455 19.6727V17.2161C18.6633 15.6291 20.0909 12.7967 20.0909 10.1557V5.98253C20.0909 4.01966 18.5025 2.41367 16.5443 2.41367H16.1023L15.1722 0.54002C14.9476 0.0867746 14.4075 -0.115461 13.9549 0.0665511L8.37791 2.31136C7.01409 2.86097 5.90909 4.50502 5.90909 5.98372V10.1557C5.90909 12.7967 7.33673 15.6291 9.45455 17.2161V19.6727L2.68509 21.3762C1.10736 21.7735 0 23.2011 0 24.838V28H26V24.838C26 23.2011 24.8926 21.7735 23.3149 21.3762Z"
      fill={color || "white"}
    />
  </svg>
);

export default ProfileIcon2;
